module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("g71h5"))).then(() => parcelRequire('d0iPb'));